export default async function funcSleep(ms:number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}